import axios from '@/axios'

export default {
  getAll(userId) {
    return new Promise((resolve, reject) => {
      let url = `/api/collections`
      if (userId) {
        url += `?userId=${userId}`
      }

      axios
        .get(url)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  create(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/collections`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  update(item) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/collections`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  remove(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/collections/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  submitOffer(id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/collections/submit/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
